"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AddOnInstance = _interopRequireDefault(require("../model/AddOnInstance"));
var _Balance = _interopRequireDefault(require("../model/Balance"));
var _BundleInstance = _interopRequireDefault(require("../model/BundleInstance"));
var _DiscountInstance = _interopRequireDefault(require("../model/DiscountInstance"));
var _Invoice = _interopRequireDefault(require("../model/Invoice"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _PlanInstance = _interopRequireDefault(require("../model/PlanInstance"));
var _RechargeInstance = _interopRequireDefault(require("../model/RechargeInstance"));
var _Service = _interopRequireDefault(require("../model/Service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Account service.
* @module api/AccountApi
* @version 3.0
*/
var AccountApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new AccountApi. 
  * @alias module:api/AccountApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AccountApi(apiClient) {
    _classCallCheck(this, AccountApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Gets a specific Invoice on an account
   * Returns the details for the account invoice specified.<br>Includes the amount due, lists of Line Items and Payments.<br>
   * @param {Number} accountId ID of the account
   * @param {Number} invoiceId ID of the invoice
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Invoice} and HTTP response
   */
  return _createClass(AccountApi, [{
    key: "getAccountInvoiceWithHttpInfo",
    value: function getAccountInvoiceWithHttpInfo(accountId, invoiceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAccountInvoice");
      }
      // verify the required parameter 'invoiceId' is set
      if (invoiceId === undefined || invoiceId === null) {
        throw new Error("Missing the required parameter 'invoiceId' when calling getAccountInvoice");
      }
      var pathParams = {
        'accountId': accountId,
        'invoiceId': invoiceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Invoice["default"];
      return this.apiClient.callApi('/accounts/{accountId}/invoices/{invoiceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a specific Invoice on an account
     * Returns the details for the account invoice specified.<br>Includes the amount due, lists of Line Items and Payments.<br>
     * @param {Number} accountId ID of the account
     * @param {Number} invoiceId ID of the invoice
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Invoice}
     */
  }, {
    key: "getAccountInvoice",
    value: function getAccountInvoice(accountId, invoiceId) {
      return this.getAccountInvoiceWithHttpInfo(accountId, invoiceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List of Account Invoices.
     * Get a list of all invoices on an Account.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Invoice>} and HTTP response
     */
  }, {
    key: "getAccountInvoicesWithHttpInfo",
    value: function getAccountInvoicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAccountInvoices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Invoice["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/invoices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List of Account Invoices.
     * Get a list of all invoices on an Account.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Invoice>}
     */
  }, {
    key: "getAccountInvoices",
    value: function getAccountInvoices(accountId) {
      return this.getAccountInvoicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-level Add-On Product Instances
     * Gets a list of Add-On Product Instances on the Account.<br>The Product Instance includes details about the Product and the display details which will aid in the display of the Product.<br>Note: will not return expired Products<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AddOnInstance>} and HTTP response
     */
  }, {
    key: "getAddOnProductInstancesWithHttpInfo",
    value: function getAddOnProductInstancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAddOnProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_AddOnInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances-addons', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-level Add-On Product Instances
     * Gets a list of Add-On Product Instances on the Account.<br>The Product Instance includes details about the Product and the display details which will aid in the display of the Product.<br>Note: will not return expired Products<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AddOnInstance>}
     */
  }, {
    key: "getAddOnProductInstances",
    value: function getAddOnProductInstances(accountId) {
      return this.getAddOnProductInstancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a Balance on the Account
     * Gets a specific Balance on the Account to get the details of the Balance.
     * @param {Number} accountId ID of the account
     * @param {Number} balanceId ID of the balance
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Balance} and HTTP response
     */
  }, {
    key: "getBalanceWithHttpInfo",
    value: function getBalanceWithHttpInfo(accountId, balanceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getBalance");
      }
      // verify the required parameter 'balanceId' is set
      if (balanceId === undefined || balanceId === null) {
        throw new Error("Missing the required parameter 'balanceId' when calling getBalance");
      }
      var pathParams = {
        'accountId': accountId,
        'balanceId': balanceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Balance["default"];
      return this.apiClient.callApi('/accounts/{accountId}/balances/{balanceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a Balance on the Account
     * Gets a specific Balance on the Account to get the details of the Balance.
     * @param {Number} accountId ID of the account
     * @param {Number} balanceId ID of the balance
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Balance}
     */
  }, {
    key: "getBalance",
    value: function getBalance(accountId, balanceId) {
      return this.getBalanceWithHttpInfo(accountId, balanceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of Balances on the Account
     * Gets a list of Balances on the Account
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Balance>} and HTTP response
     */
  }, {
    key: "getBalancesWithHttpInfo",
    value: function getBalancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getBalances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Balance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/balances', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of Balances on the Account
     * Gets a list of Balances on the Account
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Balance>}
     */
  }, {
    key: "getBalances",
    value: function getBalances(accountId) {
      return this.getBalancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all Broadband Services on the Account
     * Get a list of all active Broadband Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Service>} and HTTP response
     */
  }, {
    key: "getBroadbandServicesWithHttpInfo",
    value: function getBroadbandServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getBroadbandServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Service["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/broadband', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all Broadband Services on the Account
     * Get a list of all active Broadband Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Service>}
     */
  }, {
    key: "getBroadbandServices",
    value: function getBroadbandServices(accountId) {
      return this.getBroadbandServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-levle Bundle Product Instances
     * Gets a list of the Bundle type Product Instances on the Account. <br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BundleInstance>} and HTTP response
     */
  }, {
    key: "getBundleProductInstancesWithHttpInfo",
    value: function getBundleProductInstancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getBundleProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BundleInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances-bundles', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-levle Bundle Product Instances
     * Gets a list of the Bundle type Product Instances on the Account. <br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BundleInstance>}
     */
  }, {
    key: "getBundleProductInstances",
    value: function getBundleProductInstances(accountId) {
      return this.getBundleProductInstancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-level Discount Product Instances
     * Gets a list of the Discount type Product Instances on the Account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DiscountInstance>} and HTTP response
     */
  }, {
    key: "getDiscountProductInstancesWithHttpInfo",
    value: function getDiscountProductInstancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getDiscountProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_DiscountInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances-discounts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-level Discount Product Instances
     * Gets a list of the Discount type Product Instances on the Account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DiscountInstance>}
     */
  }, {
    key: "getDiscountProductInstances",
    value: function getDiscountProductInstances(accountId) {
      return this.getDiscountProductInstancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all Landline Services on the Account
     * Get a list of all active landline Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Service>} and HTTP response
     */
  }, {
    key: "getLandlineServicesWithHttpInfo",
    value: function getLandlineServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getLandlineServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Service["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/landline', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all Landline Services on the Account
     * Get a list of all active landline Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Service>}
     */
  }, {
    key: "getLandlineServices",
    value: function getLandlineServices(accountId) {
      return this.getLandlineServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all Mobile Services on the Account
     * Get a list of all active mobile Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Service>} and HTTP response
     */
  }, {
    key: "getMobileServicesWithHttpInfo",
    value: function getMobileServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getMobileServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Service["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/mobile', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all Mobile Services on the Account
     * Get a list of all active mobile Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Service>}
     */
  }, {
    key: "getMobileServices",
    value: function getMobileServices(accountId) {
      return this.getMobileServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-level Plan Product Instances
     * Gets a list of the Plan type Product Instances on the account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PlanInstance>} and HTTP response
     */
  }, {
    key: "getPlanProductInstancesWithHttpInfo",
    value: function getPlanProductInstancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getPlanProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PlanInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances-plans', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-level Plan Product Instances
     * Gets a list of the Plan type Product Instances on the account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PlanInstance>}
     */
  }, {
    key: "getPlanProductInstances",
    value: function getPlanProductInstances(accountId) {
      return this.getPlanProductInstancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets an account-level Product Instance
     * Gets the detail of the Product Instance on the Account specified by the input Instance ID. <br>Note: If the Product Instance has expired, this call will return an empty list<br>
     * @param {Number} accountId ID of the account
     * @param {Number} productinstanceId ID of the product instance
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getProductInstanceWithHttpInfo",
    value: function getProductInstanceWithHttpInfo(accountId, productinstanceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getProductInstance");
      }
      // verify the required parameter 'productinstanceId' is set
      if (productinstanceId === undefined || productinstanceId === null) {
        throw new Error("Missing the required parameter 'productinstanceId' when calling getProductInstance");
      }
      var pathParams = {
        'accountId': accountId,
        'productinstanceId': productinstanceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/accounts/{accountId}/productinstances/{productinstanceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets an account-level Product Instance
     * Gets the detail of the Product Instance on the Account specified by the input Instance ID. <br>Note: If the Product Instance has expired, this call will return an empty list<br>
     * @param {Number} accountId ID of the account
     * @param {Number} productinstanceId ID of the product instance
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getProductInstance",
    value: function getProductInstance(accountId, productinstanceId) {
      return this.getProductInstanceWithHttpInfo(accountId, productinstanceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-level Product Instances
     * Gets a list of all Product Instances on the Account.<br>The ‘Category’ parameter takes a Category or comma-separated list of Categories can be added to the API call to narrow down the types of Product Instances returned by the call.<br>This call is paginated if there are more than 100 instances (by default), this can be changed by passing in the itemsPerPage parameter.<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @param {Object} opts Optional parameters
     * @param {String} [category] Category
     * @param {Number} [pageNumber = 0)] The page number for pagination of multiple results
     * @param {Number} [itemsPerPage = 100)] The number of items to return per call, can override the server default but only to make it smaller
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<Object>} and HTTP response
     */
  }, {
    key: "getProductInstancesWithHttpInfo",
    value: function getProductInstancesWithHttpInfo(accountId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'category': opts['category'],
        'pageNumber': opts['pageNumber'],
        'itemsPerPage': opts['itemsPerPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [Object];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-level Product Instances
     * Gets a list of all Product Instances on the Account.<br>The ‘Category’ parameter takes a Category or comma-separated list of Categories can be added to the API call to narrow down the types of Product Instances returned by the call.<br>This call is paginated if there are more than 100 instances (by default), this can be changed by passing in the itemsPerPage parameter.<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @param {Object} opts Optional parameters
     * @param {String} opts.category Category
     * @param {Number} opts.pageNumber The page number for pagination of multiple results (default to 0)
     * @param {Number} opts.itemsPerPage The number of items to return per call, can override the server default but only to make it smaller (default to 100)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<Object>}
     */
  }, {
    key: "getProductInstances",
    value: function getProductInstances(accountId, opts) {
      return this.getProductInstancesWithHttpInfo(accountId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets a list of account-level Recharge Product Instances
     * Gets a list of Recharge type Product Instances on the Account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/RechargeInstance>} and HTTP response
     */
  }, {
    key: "getRechargeProductInstancesWithHttpInfo",
    value: function getRechargeProductInstancesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getRechargeProductInstances");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_RechargeInstance["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/productinstances-recharges', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets a list of account-level Recharge Product Instances
     * Gets a list of Recharge type Product Instances on the Account<br>Note: will not return expired Product Instances<br>
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/RechargeInstance>}
     */
  }, {
    key: "getRechargeProductInstances",
    value: function getRechargeProductInstances(accountId) {
      return this.getRechargeProductInstancesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a Service
     * Get a specific Service using the accountId and serviceId
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Service} and HTTP response
     */
  }, {
    key: "getServiceWithHttpInfo",
    value: function getServiceWithHttpInfo(accountId, serviceId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getService");
      }
      // verify the required parameter 'serviceId' is set
      if (serviceId === undefined || serviceId === null) {
        throw new Error("Missing the required parameter 'serviceId' when calling getService");
      }
      var pathParams = {
        'accountId': accountId,
        'serviceId': serviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Service["default"];
      return this.apiClient.callApi('/accounts/{accountId}/services/{serviceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a Service
     * Get a specific Service using the accountId and serviceId
     * @param {Number} accountId ID of the account
     * @param {Number} serviceId ID of the service
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Service}
     */
  }, {
    key: "getService",
    value: function getService(accountId, serviceId) {
      return this.getServiceWithHttpInfo(accountId, serviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all Services on the Account
     * Get a list of all active Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Service>} and HTTP response
     */
  }, {
    key: "getServicesWithHttpInfo",
    value: function getServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Service["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all Services on the Account
     * Get a list of all active Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Service>}
     */
  }, {
    key: "getServices",
    value: function getServices(accountId) {
      return this.getServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists all TV Services on the Account
     * Get a list of all active TV Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Service>} and HTTP response
     */
  }, {
    key: "getTVServicesWithHttpInfo",
    value: function getTVServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getTVServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Service["default"]];
      return this.apiClient.callApi('/accounts/{accountId}/services/tv', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists all TV Services on the Account
     * Get a list of all active TV Services on an Account using the accountId.
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Service>}
     */
  }, {
    key: "getTVServices",
    value: function getTVServices(accountId) {
      return this.getTVServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List of Service Types
     * Gets a list of Service Types that are under the Account
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<String>} and HTTP response
     */
  }, {
    key: "getTypesOfServicesWithHttpInfo",
    value: function getTypesOfServicesWithHttpInfo(accountId) {
      var postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getTypesOfServices");
      }
      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = ['String'];
      return this.apiClient.callApi('/accounts/{accountId}/services/types', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List of Service Types
     * Gets a list of Service Types that are under the Account
     * @param {Number} accountId ID of the account
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<String>}
     */
  }, {
    key: "getTypesOfServices",
    value: function getTypesOfServices(accountId) {
      return this.getTypesOfServicesWithHttpInfo(accountId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();